import {Grid, Box, Paper} from "@mui/material";
// import {Events} from "../sections/Events";
import Gallery from "./Gallery";
import {Projects} from "../sections/Projects";
import React from "react";
import MyTimeLine from "./MyTimeLine";

// import Gallery from "./Gallery";
// import Missions from "./Missions";


const SectionsGrid = () => {
    return (
        <Box sx={{ flexGrow: 1 }} component={"main"}>
        <Grid
            container
            spacing={1}
            sx={{ marginTop: 3,

                justifyContent: "center",
                alignItems: "stretch", } }
        >

            {/* LEFT SIDE — 25% width on md+ screens */}
            <Grid
                item
                // xs={12}
                // md={3}
                size={{ xs: 12, md: 3 }}

            >
                {/*<Events />*/}
                <MyTimeLine />
            </Grid>

            {/* RIGHT SIDE — 75% width on md+ screens */}
            <Grid
                item
                // xs={12}
                // md={9}
                size={{ xs: 12, md: 9 }}
                spacing={1}


            >
                <Box>
                    {/*<Missions />*/}
                    <Projects />
                </Box>
                <Box sx={{ marginBottom: 3 }}>
                    <Paper
                        elevation={12}
                        sx={{
                            padding: 3,
                            borderRadius: 3,
                            marginTop: 3,
                            backgroundColor: (theme) => theme.palette.missionGold.cream,
                            display: "flex",
                        }}
                    >
                    <Gallery />
                    </Paper>
                </Box>


            </Grid>

        </Grid>
        </Box>
    );
};

export default SectionsGrid;